import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useCreateTermsAndConditionsMutation } from "../../../services/termsAndConditions/termsAndConditionsApiSlice";
import { useGetTermsAndConditionsMenuQuery } from "../../../services/termsAndConditions/termsAndConditionsMenuApiSlice";
import { FormInput } from "../../../component/shared/formElements/formInput/FormInput";
import { FormRichText } from "../../../component/shared/formElements/formRichText/FormRichtext";
import { CascadingDropdowns } from "../../../component/shared/formElements/cascadingDropdown/CascadingDropdown";
import classes from "./createTermsAndConditionsPage.module.css";

export const CreateTermsAndConditionsPage = () => {
  const navigate = useNavigate();
  const [createTerms, { isLoading }] = useCreateTermsAndConditionsMutation();

  const { data: categoryItems = [], isLoading: isMenuLoading } =
    useGetTermsAndConditionsMenuQuery();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      title: "",
      category_id: null,
      content: "",
    },
    mode: "onChange",
  });

  useEffect(() => {
    register("content", {
      required: "Content is required",
      validate: (val) => {
        const text = new DOMParser()
          .parseFromString(val || "", "text/html")
          .body.textContent.trim();
        return text.length > 0 || "Content is required";
      },
    });

    register("category_id", {
      required: "Category is required",
    });
  }, [register]);

  const onSubmit = async (data) => {
    try {
      const response = await createTerms(data).unwrap();
      toast.success(
        response?.message?.displayMessage ||
          "Terms & Conditions created successfully",
      );
      navigate("/terms_and_conditions");
    } catch (err) {
      toast.error("Failed to create Terms & Conditions");
    }
  };

  if (isMenuLoading) return <p>Loading...</p>;

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.pageTitle}>Create Terms & Conditions</h2>

      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Terms & Conditions</h3>
          <div className={classes.grid}>
            <FormInput
              id="title"
              label="Title"
              register={register}
              validation={{ required: "Title is required" }}
              error={errors.title?.message}
              required
            />
          </div>
        </div>

        <div className={classes.section}>
          <h3 className={classes.sectionTitle}>Category</h3>
          <CascadingDropdowns
            items={categoryItems}
            name="category_id"
            setValue={setValue}
            error={errors.category_id?.message}
          />
        </div>

        <div className={classes.section}>
          <FormRichText
            id="content"
            label="Content"
            value={watch("content")}
            onChange={(val) =>
              setValue("content", val, { shouldValidate: true })
            }
            required
            error={errors.content?.message}
          />
        </div>

        <div className={classes.actions}>
          <button
            type="submit"
            className={classes.submitBtn}
            disabled={!isValid || isLoading}
          >
            {isLoading ? "Creating..." : "Create Terms & Conditions"}
          </button>
        </div>
      </form>
    </div>
  );
};